/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AccountDeleteSuperAdmin
 */
export interface AccountDeleteSuperAdmin {
    /**
     * 
     * @type {Array<string>}
     * @memberof AccountDeleteSuperAdmin
     */
    accountOrEmailIds: Array<string>;
}

export function AccountDeleteSuperAdminFromJSON(json: any): AccountDeleteSuperAdmin {
    return {
        'accountOrEmailIds': json['accountOrEmailIds'],
    };
}

export function AccountDeleteSuperAdminToJSON(value?: AccountDeleteSuperAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'accountOrEmailIds': value.accountOrEmailIds,
    };
}


